import React from 'react';
import styles from './ApplicatorsWidget.module.scss';
import _ from 'lodash';
import moment from 'moment';
import api from "helpers/api";
import { $t } from "helpers/translator";
import Loader from 'components/miscellaneous/Loader/Loader'
import Tooltip from "components/miscellaneous/Tooltip/Tooltip";
import { CgDanger } from "react-icons/cg";
import Timestamp from "components/miscellaneous/Timestamp/Timestamp";

class ApplicatorsWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            applicators: null,
            sortedBy: 'pulses'
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        try {
            let res = await api.get(`dashboard/applicators/usage`);
            let applicators = [];
            if (!res || !res.data || !res.data.data || !res.data.data.applicatorsUsage) {
            } else {
                applicators = res.data.data.applicatorsUsage;
            }

            _.forEach(applicators, (v, k) => {
                v.alertLevel = {
                    general: 0,
                    pulses: 0,
                    age: 0,
                };
                v.age = moment().diff(moment(v.created), 'days');

                if (v.pulses > 30000000) {
                    v.alertLevel.pulses = 1;
                    v.alertLevel.pulsesText = $t('global.chainDashboard.pulseNumberVeryHigh');
                }

                if (v.age > 14 * 30) {
                    v.alertLevel.age = 1;
                    v.alertLevel.ageText = $t('global.chainDashboard.applicatorWarrantySoonVoid');
                }
                if (v.age > 15 * 30) {
                    v.alertLevel.age = 2;
                    v.alertLevel.ageText = $t('global.chainDashboard.applicatorWarrantyVoided');
                }
            });

            this.setState({ applicators: applicators }, async () => await this.sortBy('pulses'));
        } catch (e) {
            console.error(e);
        }
    }

    async sortBy(fieldName) {
        let applicators = [ ...this.state.applicators ];
        let sortedApplicators = _.sortBy(applicators, fieldName).reverse();
        this.setState({
            applicators: sortedApplicators,
            sortedBy: fieldName
        });
    }

    render() {
        let applicators = this.state.applicators;

        return (
            <div className={ `${styles.contentContainer}` }>
                { !applicators ?
                    <Loader color={ '#ddd' } />
                    :
                    <div style={ { width: '100%' } }>

                        { applicators.length ?
                            <div>
                                <div className={ styles.orderByRow }>
                                    <div>{ $t('global.chainDashboard.orderBy') }:</div>
                                    <div onClick={ () => this.sortBy('pulses') }
                                        className={ `${styles.clickableTh} ${(this.state.sortedBy === 'pulses' ? styles.sortedByTh : '')}` }>{ $t('global.chainDashboard.pulseNumber') }</div>
                                    <div onClick={ () => this.sortBy('age') }
                                        className={ `${styles.clickableTh} ${(this.state.sortedBy === 'age' ? styles.sortedByTh : '')}` }>{ $t('global.chainDashboard.addedToClinic') }</div>
                                </div>

                                <div className={ styles.tableContainer }>
                                    {
                                        applicators.map((v, k) => {
                                            return (
                                                <div className={ styles.applicatorContainer } key={ k }>
                                                    <div className={ styles.applicatorLeftSideContainer }>
                                                        <div className={ styles.applicatorImageOuterContainer }>
                                                            <div className={ styles.applicatorImageContainer }
                                                                style={ { backgroundImage: `url(${v.image})` } }
                                                            >
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className={ styles.applicatorName }><Tooltip
                                                                content={ v.handle_id }>{ v.serial_number ? v.serial_number : 'N/A' }</Tooltip></div>
                                                            <div>{ v.name }</div>
                                                            {
                                                                /*
                                                                <div className={styles.sameRowFlex}>
                                                                {v.alertLevel.age ?
                                                                    <Tooltip
                                                                        content={$t(`global.chainDashboard.${v.alertLevel.ageText}`)}>
                                                                        <CgDanger
                                                                            className={`${styles.dangerIcon} ${v.alertLevel.age < 2 ? styles.yellow : styles.red}`}/>
                                                                    </Tooltip>
                                                                    : <CgDanger className={`${styles.dangerIcon}`}
                                                                                style={{ opacity: '0' }}/>
                                                                }
                                                                <div className={styles.flex}><div>{$t('global.chainDashboard.added')}</div> <span><Timestamp time={v.created}/></span></div>
                                                            </div>
                                                                */
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className={ styles.applicatorRightSideContainer }>
                                                        <div>
                                                            <div className={ styles.sameRowFlex }>
                                                                { v.alertLevel.pulses ?
                                                                    <Tooltip
                                                                        content={ $t(`global.chainDashboard.${v.alertLevel.pulsesText}`) }>
                                                                        <CgDanger
                                                                            className={ `${styles.dangerIcon} ${v.alertLevel.pulses < 2 ? styles.yellow : styles.red}` } />
                                                                    </Tooltip>
                                                                    : <></>
                                                                }
                                                                <div>{ v.pulses > 0 ? v.pulses.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 } { $t(`global.chainDashboard.pulses`) }</div>
                                                            </div>

                                                            <div className={ styles.sameRowFlex }>
                                                                { v.alertLevel.age ?
                                                                    <Tooltip
                                                                        content={ $t(`global.chainDashboard.${v.alertLevel.ageText}`) }>
                                                                        <CgDanger
                                                                            className={ `${styles.dangerIcon} ${v.alertLevel.age < 2 ? styles.yellow : styles.red}` } />
                                                                    </Tooltip>
                                                                    : <></>
                                                                }
                                                                {/*<Tooltip content={moment(v.created).format('LLL')}>{$t('global.chainDashboard.added')} {moment(v.created).fromNow()}</Tooltip>*/ }
                                                                <div className={ styles.flex }><div>{ $t('global.chainDashboard.added') }</div> <span><Timestamp time={ v.created } /></span></div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>{ $t('global.chainDashboard.clinic') }:</div>
                                                            <div>{ v.clinic_name }</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            );
                                        }
                                        )
                                    }
                                </div>
                            </div>
                            :
                            <div>{ $t('global.chainDashboard.noApplicatorsUsed') }</div>
                        }

                    </div>
                }
            </div>
        );
    }
}

export default ApplicatorsWidget;
